// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import * as Plugin_0 from '/data/heran/operation-front-end/operation-front-end-docker-sys_prod_gy/src/app.ts';
import * as Plugin_1 from '@@/core/helmet.ts';
import * as Plugin_2 from '/data/heran/operation-front-end/operation-front-end-docker-sys_prod_gy/src/.umi-production/plugin-model/runtime.tsx';
import * as Plugin_3 from '/data/heran/operation-front-end/operation-front-end-docker-sys_prod_gy/src/.umi-production/plugin-qiankun-master/masterRuntimePlugin.tsx';
import { PluginManager } from 'umi';

function __defaultExport (obj) {
  if (obj.default) {
    return typeof obj.default === 'function' ? obj.default() :  obj.default
  }
  return obj;
}
export function getPlugins() {
  return [
    {
      apply: __defaultExport(Plugin_0),
      path: process.env.NODE_ENV === 'production' ? void 0 : '/data/heran/operation-front-end/operation-front-end-docker-sys_prod_gy/src/app.ts',
    },
    {
      apply: Plugin_1,
      path: process.env.NODE_ENV === 'production' ? void 0 : '@@/core/helmet.ts',
    },
    {
      apply: Plugin_2,
      path: process.env.NODE_ENV === 'production' ? void 0 : '/data/heran/operation-front-end/operation-front-end-docker-sys_prod_gy/src/.umi-production/plugin-model/runtime.tsx',
    },
    {
      apply: Plugin_3,
      path: process.env.NODE_ENV === 'production' ? void 0 : '/data/heran/operation-front-end/operation-front-end-docker-sys_prod_gy/src/.umi-production/plugin-qiankun-master/masterRuntimePlugin.tsx',
    },
  ];
}

export function getValidKeys() {
  return ['patchRoutes','patchClientRoutes','modifyContextOpts','modifyClientRenderOpts','rootContainer','innerProvider','i18nProvider','accessProvider','dataflowProvider','outerProvider','render','onRouteChange','antd','qiankun','useQiankunStateForSlave','request',];
}

let pluginManager = null;

export function createPluginManager() {
  pluginManager = PluginManager.create({
    plugins: getPlugins(),
    validKeys: getValidKeys(),
  });


  return pluginManager;
}

export function getPluginManager() {
  return pluginManager;
}
